import { useTranslation } from 'react-i18next'
import React from 'react'

import Center from './Center'
import IconBlock from '../../../../components/presentation/IconBlock'
import Loading from './Loading'

const Context = React.createContext({})
const { Provider } = Context
export const useStatePresenter = () => React.useContext(Context) || {}
export const useIsRefetching = () => useStatePresenter().isRefetching

const EmptyMessage = () => {
  const { t } = useTranslation('common')
  return (
    <Center height="100%">
      <IconBlock icon="BsInbox" title={t('emptyMessage')} />
    </Center>
  )
}

const ErrorMessage = ({ error }) => {
  const { t } = useTranslation('common')
  return (
    <Center>
      <IconBlock icon="BsExclamationTriangle" title={t('errorMessage')} subtitle={JSON.stringify(error)} />
    </Center>
  )
}

export const RefetchingIndicator = () => {
  const loading = useIsRefetching()
  if (!loading) return false
  return <Loading justify="flex-start" type="spin" />
}

const StatePresenter = ({ children, uncontrolledChildren, size, noEmptyMessage, ...state }) => {
  const { loading, isFetchingMore, isRefetching, error, empty } = state
  let content = children

  if (loading && !isRefetching) content = <Loading size={size} />
  if (!loading && !!empty) content = !!noEmptyMessage ? false : <EmptyMessage />
  if (error) content = <ErrorMessage error={error} />

  return (
    <Provider value={state}>
      {uncontrolledChildren}
      {content}
      {isFetchingMore && (
        <div>
          <Loading />
        </div>
      )}
    </Provider>
  )
}

export default StatePresenter
